import { apiRequest } from '@/utils/api-request';

const BASE = '/api/parent-app/admin';

export type AudienceType = 'school' | 'class' | 'section' | 'student';
export type NotifType    = 'announcement' | 'ptm' | 'event' | 'exam' | 'holiday' | 'attendance' | 'fee_updated' | 'gallery';

export interface PaClassItem {
  id: number;
  class_name: string;
  curriculum_name: string;
  curriculum_class_id: number | null;
  section_id: number | null;
  is_active: boolean;
}

export interface StudentItem {
  id: number;
  display_name: string;
  admission_number: string | null;
  class_id: number | null;
}

export interface BroadcastRecord {
  id: number;
  audience_type: AudienceType;
  audience_id: number | null;
  type: NotifType;
  title: string;
  body: string;
  sent_to: number;
  created_at: string;
  sent_by_role: 'school_admin' | 'teacher';
}

export interface BroadcastPayload {
  audience_type: AudienceType;
  audience_id?: number;
  section_id?: number;
  type: NotifType;
  title: string;
  body: string;
}

export const notificationsApi = {
  getClasses: () =>
    apiRequest<{ data: PaClassItem[] }>(`${BASE}/classes?limit=200`),

  getStudents: (search?: string) => {
    const qs = search ? `search=${encodeURIComponent(search)}&limit=30` : 'limit=30';
    return apiRequest<{ data: StudentItem[] }>(`${BASE}/students?${qs}`);
  },

  broadcast: (payload: BroadcastPayload) =>
    apiRequest<{ sent_to: number }>(`${BASE}/notifications/broadcast`, {
      method: 'POST',
      body: JSON.stringify(payload),
    }),

  getHistory: (page = 1) =>
    apiRequest<{ data: BroadcastRecord[]; total: number; page: number; limit: number }>(
      `${BASE}/notifications/broadcasts?page=${page}&limit=20`
    ),
};
